import 'angular'

import { downgradeComponent } from '@angular/upgrade/static'

import { BetaWarningComponent } from './beta-warning.component'

angular.module('app-lite.messages.beta-warning', [])
  .directive('worBetaWarning', downgradeComponent({ component: BetaWarningComponent }));
